import { ReactElement, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

export const ScrollToAnchor = (): ReactElement | null => {
  const location = useLocation();
  const lastHash = useRef("");

  useEffect(() => {
    if (location.hash) {
      lastHash.current = location.hash.slice(1);
    }

    if (lastHash.current) {
      const element = document.getElementById(lastHash.current);
      if (element) {
        const originalScrollMargin = element.style.scrollMarginTop;
        element.style.scrollMarginTop = "80px";

        setTimeout(() => {
          element.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });

          element.style.scrollMarginTop = originalScrollMargin;
          lastHash.current = "";
        }, 100);
      }
    }
  }, [location]);

  return null;
};
